<template>
	<div>
		<div
			v-if="mappingTime"
			:style="'border-radius: 5px'"
		>
			<div style="display: flex; gap: 1rem">
				<i
					style="font-size: 1rem; height: fit-content; margin: auto 0; cursor: pointer"
					class="fas fa-arrow-left"
					@click="backIcon"
				/>
				<h1 style="margin: 0">
					{{ $t('mapProperties') }}
				</h1>
			</div>
			<p>{{ $t('mapColumnsAndFixErrors') }}</p>
			<div v-if="!showOutliers">
				<slot name="cards" />
			</div>
			<div v-if="!showOutliers">
				<div class="flex items-center justify-between gap-2 justify-end py-4 w-full">
					<div class="cursor-pointer flex gap-2 w-fit rounded text-[0.8rem]">
						<a
							class="hover:underline"
							@click="$emit('exportarOutliers')"
							>{{ $t('exportarAnaliseMedicao') }}</a
						>
						<label
							style="cursor: pointer"
							for="newFile"
						>
							{{ $t('arquivoEmEdicao') }} {{ filename }}
							<a class="hover:underline"> {{ $t('replaceMeasurement') }}</a>
							<input
								id="newFile"
								type="file"
								style="display: none"
								@change="$emit('change', $event.srcElement.files[0])"
							/>
						</label>
					</div>
					<Checkbox
						v-model="showInAttention"
						label="Exibir apenas linhas com problemas"
						:disabled="inconsistentes.length === 0"
					/>
					<InputSearch
						v-model="query"
						class="!w-[30%]"
					/>
				</div>
				<div
					v-if="data.length"
					class="datamapper__grid__container"
				>
					<table
						cellspacing="0"
						style="max-width: 80vw; background-color: #ffffff"
					>
						<thead
							style="background-color: #fafdfb; display: table; width: 100%; table-layout: fixed"
							:style="hasScroll ? 'width: calc( 100% - 0.6em )' : '100%'"
						>
							<!-- <th style="
                  position: sticky;
                  position: -webkit-sticky;
                  border: solid 0.5px #ccc;
                  width: 3rem;
                ">
              <i v-if="inconsistentes.length" :title="inconsistentes.length + ' medições inconsistenstes'"
                class="fas fa-exclamation-triangle" style="color: #9B5400"></i>
              <i v-else title="A base está válida" style="color: #138600" class="fas fa-check-circle"></i>
            </th> -->
							<th
								v-for="coluna in colunas"
								:key="coluna.key"
								style="border: solid 0.5px #ccc"
							>
								<div style="display: flex; justify-content: space-between; padding: 0.5rem">
									<div>
										<p
											style="font-size: 0.9rem; color: rgb(var(--color-primary)); margin-bottom: 0"
										>
											{{ `${coluna.nome} ${coluna.unidade || ''}` }}
										</p>
										<p
											style="
												font-size: 0.5rem;
												color: rgb(var(--color-primary));
												margin-bottom: 0;
												text-align: start;
											"
										>
											{{ value.find((ca) => ca.value === coluna.key).key }}
										</p>
									</div>
									<KebabMenu
										icon="fas fa-chevron-circle-down"
										:options="atributos"
										style="
											transform: initial;
											color: rgb(var(--color-primary));
											position: relative !important;
											margin: auto 0;
										"
										@input="bindColuna($event, coluna.key)"
									/>
								</div>
							</th>
						</thead>
						<tbody
							ref="tbody_medicao"
							style="max-height: 60vh; display: block; overflow: auto"
						>
							<tr
								v-for="(dado, index) in pageData"
								:key="dado.id"
								style="display: table; width: 100%; position: relative"
							>
								<!-- <td style="
                    position: sticky;
                    position: -webkit-sticky;
                    padding: 0.7rem;
                    font-size: 0.8rem;
                    border: 0.5px solid #ccc;
                    display: flex;
                    justify-content: center;
                    position: sticky;
                    left: 0;
                    background: white;
                    z-index: 1;
                    width: 3rem;
                  ">
                <div style="position: absolute; width: 60px; left: -50px">
                  x
                </div>
                <i v-if="dado.inconsistencias.length" :title="dado.inconsistencias
                  .map((i) => '• ' + i + '\n')
                  .join()
                  .replaceAll(',', '')
                  " class="fas fa-exclamation-triangle" style="color: #9B5400"></i>
                <i v-else title="Registro está correto." style="color: #138600" class="fas fa-check-circle"></i>
              </td> -->
								<TableCell
									v-for="attr in value"
									:id="dado.id"
									:key="Object.values(attr).toString() + index"
									:cellvalue="dado[attr.key]"
									:cellkey="attr.key"
									@changed="hangleChange"
								>
									<div style="display: flex; position: relative">
										<!-- <input style="outline: none" v-model="dado[attr.key]" :id="dado.id" type="text"
                      :placeholder="dado[attr.key]" /> -->
										{{ dado[attr.key] }}
										<i
											v-if="validate(attr.coluna, dado[attr.key])"
											:title="validate(attr.coluna, dado[attr.key], dado.id)"
											class="fas fa-exclamation-triangle"
											style="position: absolute; right: 0; margin: 0.3rem 0; color: #9b5400"
										/>
									</div>
								</TableCell>
								<td
									v-if="dado.id === showById"
									style="position: absolute; right: 0"
								>
									<div style="padding: 0.3rem 1rem; margin: 2px">
										<i
											v-if="!(agree && showById)"
											class="fas fa-trash"
											@click="agree = true"
										/>
										<i
											v-if="agree && showById"
											style="color: #ccbea0"
											:title="$t('clickConfirm')"
											class="fas fa-exclamation-circle"
											@click="deletaMedicao"
										/>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div
					v-else
					style="
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;
						padding: 3rem 1rem;
						color: rgb(var(--color-primary));
					"
				>
					<i
						class="fas fa-file-csv"
						style="font-size: 1.5rem; margin-bottom: 0.5rem"
					/>
					<p style="margin: 0">
						{{ $t('semRegistrosParaExibir') }}
					</p>
				</div>
				<div
					v-if="data.length"
					class="container__crud__pagination py-2 flex w-full flex-col gap-8"
				>
					<Pagination
						ref="ref__pagination"
						:quantity-per-page="quantityPerPage"
						:quantity-per-page-options="[5, 10, 15]"
						:total-records="
							showInAttention
								? inconsistentes.length
								: data.filter((d) => !medicoesDesconsideradas.includes(d.id)).length
						"
						@setStartEnd="setStartEnd"
						@setQuantityPerPage="setQuantityPerPage"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Checkbox from '../Checkbox/Checkbox.vue'
import InputSearch from '../InputSearch/InputSearch.vue'
import KebabMenu from '../KebabMenu/KebabMenu.vue'
import Pagination from '../Pagination/Pagination.vue'
import TableCell from '../TableCell/TableCell.vue'

import ControllingPaginationMixins from '../../mixins/ControllingPaginationMixins'

import { mapMutations } from 'vuex'

export default {
	components: {
		KebabMenu,
		Pagination,
		TableCell,
		Checkbox,
		InputSearch,
	},
	mixins: [ControllingPaginationMixins],
	props: {
		hasChart: {
			type: Boolean,
			default: false,
		},
		isEdit: {
			type: Boolean,
			default: false,
		},
		filename: {
			type: String,
			default: '',
		},
		data: {
			type: Array,
			default: () => [],
		},
		colunas: {
			type: Array,
		},
		value: {
			type: Array,
		},
		step: {
			type: Number,
		},
	},
	data() {
		return {
			query: '',
			showInAttention: false,
			showOutliers: false,
			colunaAtributo: [],
			finalmente: false,
			mappingTime: true,
			hasScroll: false,
			medicoesInconsistentes: [],
			showNewMedicaoForm: false,
			showById: null,
			agree: false,
			medicoesDesconsideradas: [],
		}
	},
	computed: {
		inconsistentes() {
			return this.data
				.filter((medicao) => !this.medicoesDesconsideradas.includes(medicao.id)) // não verifica as medições desconsideradas
				.map((f) =>
					this.colunas
						.filter((ff) => typeof ff.validator === 'function')
						.map((coluna) => [
							f.id,
							coluna.validator(f[this.value.find((v) => v.value === coluna.key).key]),
						])
						.filter((f) => f[1] != null),
				)
				.filter((f) => f.length)
				.flat()
		},
		pageData() {
			return this.data
				.filter((f) => Object.values(f).toString().toLowerCase().includes(this.query.toLowerCase()))
				.filter((f) =>
					!this.showInAttention ? f : this.inconsistentes.map(([id]) => id).includes(f.id),
				)
				.filter((medicao) => !this.medicoesDesconsideradas.includes(medicao.id))
				.slice(this.atualStartIndex, this.atualEndIndex)
		},
		atributos() {
			// planilha sem linhas (aba vazia ou só cabeçalho) não pode quebrar o render
			if (!this.data.length) return []

			return Object.keys(this.data[0])
				.filter(
					(f) =>
						!['id', 'insights', 'codigoArvore', 'inconsistencias', 'codigo', 'nivelRisco'].includes(
							f,
						),
				)
				.map((m) => {
					return { value: m, label: m }
				})
		},
		uniqueColumns() {
			const obj = []
			this.value
				.map((m) => m.key)
				.forEach((f) => {
					obj.push([f, [...new Set(this.data.map((m) => m[f]))]])
				})

			return Object.fromEntries(obj)
		},
	},

	created() {
		this.quantityPerPage = 10
	},
	updated() {
		window.addEventListener('resize', () => {
			this.hasScroll = this.$refs.tbody_medicao.scrollHeight > this.$refs.tbody_medicao.clientHeight
		})
	},
	methods: {
		hangleChange(value) {
			this.$emit('cellChanged', value)
		},
		...mapMutations('moduleMessages', ['mutationShowMessage']),

		backIcon() {
			this.$emit('previous')
			if (this.mappingTime && !this.showOutliers) {
				this.mappingTime = true
			} else {
				this.mappingTime = true
				this.showOutliers = false
			}
		},
		continuar() {
			this.$emit('next')
			if (this.mappingTime && !this.hasChart) {
				this.finalmente = true
				this.mappingTime = false
			} else if (this.showOutliers) {
				this.finalmente = true
				this.mappingTime = false
			} else {
				this.showOutliers = true
			}
		},

		deletaMedicao() {
			this.medicoesDesconsideradas.push(this.showById)
			this.agree = false
			this.medicoesInconsistentes = this.data
				.filter((medicao) => !this.medicoesDesconsideradas.includes(medicao.id))
				.filter((medicao) => medicao.inconsistencias.length > 0)
		},
		validate(col, data) {
			const coluna = this.colunas.find((coluna) => {
				return coluna.nome === col
			})

			const hasError = coluna.validator ? coluna.validator(data) : null

			return hasError
		},
		bindColuna(e, col) {
			console.log('🚀 ~ bindColuna ~ e:', e)
			console.log('🚀 ~ bindColuna ~ col:', col)
			const { intent } = e

			this.value.forEach((ca) => {
				if (ca.value === col) {
					ca.key = intent
				}
			})

			this.$emit('change', this.value)
			this.$emit('input', this.value)
		},
	},
	watch: {
		medicoesInconsistentes: {
			handler(value) {
				if (value.length) {
					this.showInAttention = false
				}
			},
			deep: true,
		},
		data: {
			handler(v) {
				this.medicoesInconsistentes = v
					.filter((medicao) => !this.medicoesDesconsideradas.includes(medicao.id))
					.filter((medicao) => medicao.inconsistencias.length > 0)
			},
			deep: true,
			immediate: true,
		},
	},
}
</script>

<style scoped>
table {
	max-width: 80vw;
	overflow: scroll !important;
}

#button-dropdown-kebab {
	padding: 0;
}

.datamapper__grid__container {
	max-width: 90vw;
	max-height: 50vh;
	overflow: auto;
	border-radius: 5px;
}

.datamapper__guide__container {
	display: flex;
	gap: 1rem;
	flex-direction: column;
	border-radius: 10px;
	max-height: 50vh;
	overflow: auto;
}
h1 {
	font-size: 1.5rem;
	margin: calc(1.5rem - 0.14285714em) 0 0.5rem;
}
</style>
